import React from 'react'

export class About extends React.Component {
    constructor() {
        super();
    
        this.state = {person: []};
    }
    componentDidMount() {
        fetch('https://jsonplaceholder.typicode.com/users')
        .then(response =>  response.json())
        .then(resData => {
           console.log(resData)
           //do your logic here       
           //let person = resData.results
           this.setState({ person: resData }); //this is an asynchronous function
        })
    }
    render(){
        return(
            <ul>
                { 
                this.state.person.map((personRecord) => {
                    return <li key={personRecord.id}> {personRecord.name} </li>
                })
                }
            </ul>
        );
    }
}